import React from 'react';
import { FieldProps } from 'formik';
import { TextFieldProps } from '@lifeomic/chroma-react/components/TextField';
import { FormikMaskedTextField } from '../MaskedTextField';

export const dateInputMask = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export interface DateFieldOwnProps {
  input?: TextFieldProps;
}

export type DateFieldProps = FieldProps & DateFieldOwnProps;

const DateField = (props: DateFieldProps) => {
  return (
    <FormikMaskedTextField
      {...props}
      mask={dateInputMask}
      placeholder="MM/DD/YYYY"
      placeholderChar={'_'}
    />
  );
};

export default React.memo(DateField);
